import { TripStatusFilters } from '../../../enums';

export interface IKanbanFilters {
    scheduledDate?: [string, string] | undefined;
    scheduledLoad?: [string, string] | undefined;
    visitDate?: [string, string] | undefined;
    realFinish?: [string, string] | undefined;
    realStart?: [string, string] | undefined;
    realLoad?: [string, string] | undefined;
    licensePlate?: string[] | undefined;
    vehicleIds?: string[] | undefined;
    driverIds?: string[] | undefined;
    carrierIds?: string[] | undefined;
    origin?: string[] | undefined;
    destination?: string[] | undefined;
    status?: TripStatusFilters[];
    tags?: string[] | undefined;
    serviceTypeIds?: string[] | undefined;
    tripCode?: string | undefined;
    accounts?: string[] | undefined;
}

export interface IKanbanColumnsArgs {
    from?: string;
    to?: string;
    filters?: IKanbanFilters;
    tripDefinitionId?: string;
    requestId?: string;
}
